import { render, staticRenderFns } from "./LabelDescription.vue?vue&type=template&id=0c4d8b24&scoped=true&"
import script from "./LabelDescription.vue?vue&type=script&lang=js&"
export * from "./LabelDescription.vue?vue&type=script&lang=js&"
import style0 from "./LabelDescription.vue?vue&type=style&index=0&id=0c4d8b24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d8b24",
  null
  
)

export default component.exports